<template>
  <div>
    <div class="controls controls-end d-flex flex-column " v-if="!hide_options">
      <div>
        <v-btn color="primary" outlined fab small :disabled="zoom >= maxZoom" @click="increaseZoom">
          <v-icon v-once>mdi-plus</v-icon>
        </v-btn>
        <v-btn class="ml-2" color="primary" outlined fab small :disabled="zoom <= minZoom" @click="decreaseZoom">
          <v-icon v-once>mdi-minus</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="controls control-light controls-end d-flex flex-column " v-if="!hide_options">
      <div v-if="currentDocument">
        <show-boxes-btn :key="currentDocument.id.toString()"/>
      </div>
      <show-download-doc-btn class="control-show-btn"/>
      <show-delete-doc-btn/>
    </div>
    <div>
      <div v-if="firstPageDownloaded" class="viewer pdf-viewer">
        <div v-if="showRotation" class="controls d-flex justify-start">
          <v-btn class="mr-2" color="primary" outlined fab small @click="rotate(-90)">
            <v-icon v-once>mdi-format-rotate-90</v-icon>
          </v-btn>
          <v-btn color="primary" outlined fab small @click="rotate(90)">
            <v-icon v-once style="transform: rotateY(180deg);">mdi-format-rotate-90</v-icon>
          </v-btn>
        </div>
        <PDFPageV3 :page="pages[index]" v-bind:style="{ zoom }" class="pdf-document"></PDFPageV3>
        <PDFPaginator v-if="pageCount > 1" :pageCount="pageCount" @page-changed="setVisiblePage" />
      </div>
      <div class="loading-pdf" v-else>
        <v-progress-circular v-if="!firstPageDownloaded" indeterminate color="primary">
        </v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import PDFPageV3 from './PDFPageV3.vue'
import PDFPaginator from '../PDFPaginator.vue'
import ShowBoxesBtn from '../ShowBoxesBtn.vue';
import ShowDeleteDocBtn from '../ShowDeleteDocBtn.vue';
import ShowDownloadDocBtn from '../ShowDownloadDocBtn.vue';

export default {
  name: 'PDFViewerV3',
  props: {
    url: {
      type: String,
      default: undefined,
    },
    hide_options: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PDFPageV3,
    PDFPaginator,
    ShowBoxesBtn,
    ShowDeleteDocBtn,
    ShowDownloadDocBtn,
  },
  data() {
    return {
      index: 0,
      page: undefined,
      maxZoom: 3,
      minZoom: 0.4,
    };
  },
  computed: {
    ...mapState("pdf_data", [
      'pages',
      'firstPageDownloaded',
    ]),
    showRotation() {
      return this.inRotationMode
    },
    counterZoom() {
      return 1 / this.zoom
    },
    pageCount() {
      return this.pages.length
    },
    currentPage() {
      return this.pages[this.index].numPage
    },
    ...mapGetters({
      zoom: "documents/zoom",
      inRotationMode: "documents/inRotationMode",
      rotationMode: "documents/rotationMode",
      currentDocument: "documents/currentDocument",
    }),
  },
  methods: {
    ...mapActions({
      setDocumentUrl: "pdf_data/setDocumentUrl",
      cleanDocument: "pdf_data/cleanDocument",
      setPageVisible: "pdf_data/setPageVisible",
      doRotate: 'documents/doRotate',
      setZoom: "documents/setZoom",
      setCurrentPage: 'setCurrentPage',
    }),
    rotate(deg) {
      if (this.rotationMode === 'all') {
        this.doRotate({ rotation: deg })
      }
      else {
        this.doRotate({ page: this.currentPage, rotation: deg })
      }
    },
    increaseZoom() {
      const zoom = Math.min(this.zoom + .1, this.maxZoom)
      this.setZoom(zoom)
    },
    decreaseZoom() {
      const zoom = Math.max(this.zoom - .1, this.minZoom)
      this.setZoom(zoom)
    },
    setVisiblePage(pageNumber) {
      this.setPageVisible({ numPage: this.index + 1, visible: false })
      this.index = pageNumber - 1
      this.setPageVisible({ numPage: pageNumber, visible: true })
    },
  },
  mounted() {
    if (this.url) {
      this.setDocumentUrl(this.url)
    }
  },
  destroyed() {
    this.cleanDocument()
    this.setCurrentPage(1)
  },

}
</script>

<style scoped>
.viewer {
  background-color: #999999;
  overflow: auto;
}

.controls {
  position: absolute;
  z-index: 100;
  margin-top: 15px;
  left: 15px;
}

.controls>>>button {
  background-color: white;
}

.controls-end {
  left: auto;
  right: 30px;
}

.pdf-viewer .pdf-viewer__document,
.pdf-viewer .pdf-viewer__preview {
  top: 0px;
}

.pdf-paginator {
  z-index: 11;
  position: absolute;
  bottom: 3%;
  left: auto;
  right: 50%;
  -webkit-transform: translateX(50%);
  transform: translateX(50%);
}

.pdf-document {
  position: absolute;
  overflow: auto;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #525f69;
}

.loading-pdf {
  display: block;
  margin: 0 auto;
  background-color: #ffffff;
}

@media only screen and (max-width: 600px) {
  .pdf-paginator {
    bottom: 2.5%;
    right: 30%;
    -webkit-transform: translateX(30%);
    transform: translateX(30%);
    position: fixed;
  }
}
.control-light{
    margin-top: 60px;
  }
.control-show-btn{
  margin-bottom: 5px;
}
</style>
